import { render, staticRenderFns } from "./BagPurchase.vue?vue&type=template&id=7789332a&scoped=true"
import script from "./BagPurchase.vue?vue&type=script&lang=js"
export * from "./BagPurchase.vue?vue&type=script&lang=js"
import style0 from "./BagPurchase.vue?vue&type=style&index=0&id=7789332a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789332a",
  null
  
)

export default component.exports